/*
  WURI (World's Universities with Real Impact) inovasyon siralamasi.

  Buradaki her bilgi asagidaki kaynaklardan dogrulandi. Kaynaklar yalnizca
  ilk uc sirayi numarasiyla veriyor; ilk 10'daki diger kurumlar adlariyla
  anilip sira numarasi verilmiyor. Bu yuzden "alsoTopTen" listesinde
  numara yok; siralari tahmin edilmedi, liste yalnizca taninirliga gore dizildi — tahmini bir sira yazmak bu sayfayi
  yanlis bilgi yayan bir sayfaya cevirirdi. Ilk uc belli oldugu icin bu
  kurumlarin hepsinin 42'nin gerisinde oldugu ise kesin.
*/

export const podium2026 = [
  { rank: 1, name: "Minerva University", country: "United States" },
  { rank: 2, name: "Arizona State University", country: "United States" },
  { rank: 3, name: "42", country: "France · global network", highlight: true },
];

export const alsoTopTen2026 = [
  { name: "Massachusetts Institute of Technology", short: "MIT", country: "United States" },
  { name: "Stanford University", short: "Stanford", country: "United States" },
  { name: "California Institute of Technology", short: "Caltech", country: "United States" },
  { name: "University of Pennsylvania", short: "Penn", country: "United States" },
  { name: "Incheon National University", short: "INU", country: "South Korea" },
];

export const history = [
  { year: "2023", rank: 6, note: "Ahead of Princeton, Harvard, Oxford and Cambridge" },
  { year: "2024", rank: 6, note: "Ahead of Stanford (11th) and Harvard (12th)" },
  { year: "2025", rank: 3, note: "First time on the podium" },
  { year: "2026", rank: 3, note: "Second year in a row" },
];

export const sources = [
  {
    label: "Fundación Telefónica — WURI 2023",
    url: "https://en.fundaciontelefonica.com/news/campus-42-rises-in-the-top-10-of-the-most-innovative-universities/",
  },
  {
    label: "Freenews — WURI 2024",
    url: "https://www.freenews.fr/iliad/lecole-42-une-reference-mondiale-en-innovation-et-valeurs-ethiques-selon-le-classement-wuri-2024",
  },
  {
    label: "42 Network — 42 ranks 3rd worldwide for innovation",
    url: "https://www.42network.org/blog/breaking-news-42-ranks-3rd-worldwide-for-innovation/",
  },
  {
    label: "Fundación Telefónica — 3rd for the second consecutive year",
    url: "https://www.fundaciontelefonica.com/noticias/42-tercera-universidad-mas-innovadora-del-mundo-por-segundo-ano-consecutivo/",
  },
  {
    label: "Minerva University — WURI 2026 top 10",
    url: "https://www.minerva.edu/announcements/minerva-university-named-worlds-most-innovative-university-for-fifth-consecutive-year/",
  },
];
